import { render, staticRenderFns } from "./Rotateimg.vue?vue&type=template&id=1b619429&scoped=true&"
import script from "./Rotateimg.vue?vue&type=script&lang=js&"
export * from "./Rotateimg.vue?vue&type=script&lang=js&"
import style0 from "./Rotateimg.vue?vue&type=style&index=0&id=1b619429&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b619429",
  null
  
)

export default component.exports